import React from 'react'
import {Grid} from '@material-ui/core'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'

import messages from './messages'
import useStyles from './styles'

export default function Dropzone(props){

    const { dropzone, header1, header2, header3, header4 } = messages
    const { accept, headerText, headerStyle, enableHeader=true, dzoneProps:{getInputProps, getRootProps } } = props
    const classes = useStyles()

    return (
        <Grid container item xs={12}>
            { enableHeader && headerText &&
                <Grid item xs={12}>
                    <span style={{...headerStyle}}>
                        {headerText}
                    </span>
                </Grid>
            }
            { enableHeader && !headerText &&
                <Grid container item xs={12}>
                        <p className={classes.header1}>
                            {header1}
                        </p>
                        <p className={classes.header1}>
                            {header2}
                        </p>
                        <p className={classes.header1}>
                            {header3}
                        </p>
                        <p className={classes.header4}>
                            {header4}
                        </p>
                </Grid>
            }
            <Grid item xs={12}>
            <div {...getRootProps({ className: classes.dropzone })}>
                <input {...getInputProps()} />
                <div className={classes.dZoneInput}>
                    <div>
                        <div className={classes.uploadIcon}>
                            <CloudUploadIcon />
                        </div>
                    </div>
                    <div style={{width: '100%'}}>
                        <div className={classes.uploadMessage}>
                            <div id={dropzone.id} data-testid={dropzone.id}>
                                <span dangerouslySetInnerHTML={dropzone.defaultMessageHTML}/>
                            </div>
                        </div>
                        <div className={classes.maxSizeMessage}>
                            <span>{dropzone.maxFileSize.text}</span>
                        </div>
                        <div className={classes.fileTypesMessage}>
                            <span>
                                {dropzone.fileTypes(accept)}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            </Grid>
        </Grid>
    )
}